import { Container, Row } from "reactstrap";
import RegistrationWithBgImageContainer from "../../Componant/Authentication/RegistrationWithBgImage";

const RegistrationWithBgImage = () => {
  return (
    <Container fluid>
      <Row>
        <RegistrationWithBgImageContainer />
      </Row>
    </Container>
  );
};

export default RegistrationWithBgImage;
